import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from '@plootus/common';
import { BrowserRouter } from 'react-router-dom';
import { LastLocationProvider } from './routing/LastLocationProvider';
import ContextProvider from './Reusables/VisualAndAccord/Context/Context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 30, // 30 minutes
      refetchOnWindowFocus: false,
    },
  },
});

const GOOGLE_CLIENT_ID = "489405425763-cghs67b7r4ein9iimqaunnaip8j4h05d.apps.googleusercontent.com";

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter>
            <LastLocationProvider>
              <ContextProvider>
                {/* // Developed and managed by Mejona technology */}

                <App />
              </ContextProvider>
            </LastLocationProvider>
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
